import { createBrowserRouter } from "react-router-dom";
import type { RouteObject } from "react-router-dom";
import { Layout } from "./shared-widgets";
import { Login, Menu, Orders, PastOrders } from "./widgets";

export const routePaths = {
	ROOT: {
		path: "/",
		name: "Menu",
	},
	ORDERS: {
		path: "/orders",
		name: "Orders",
	},
	PAST_ORDERS: {
		path: "/past-orders",
		name: "Past Orders",
	},
};

const routes: RouteObject[] = [
	{
		path: "/",
		element: <Layout />,
		children: [
			{
				path: "/",
				element: <Menu />,
			},
			{
				path: "/orders",
				element: <Orders />,
			},
			{ path: "/past-orders", element: <PastOrders /> },
		],
	},
	{ path: "/login", element: <Login /> },
];

const router = createBrowserRouter(routes);

export default router;
